import React, { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
import Traductor from '../Traductor';

import '../../css/components/bronson/rangeSlider.css';

function RangeSlider({ options, value, setValue }) {
    const t = new Traductor();
    const [minValue, setMinValue] = useState(value[0] ? value[0] : 0);
    const [maxValue, setMaxValue] = useState(value[1] ? value[1] : 1);
    const [innerState, setInnerState] = useState();

    useEffect(() => {
        //If dragged value/innerState and innerState isn't equal to filter value -> Update slider with dragged value/innerState
        //If filter value and slider value and not equal and not dragged value/innerState -> Update slider with filter value
        const slider = window.bronson
            .$$('#' + options.id + '.js-custom-range-slider')
            .component('custom-range-slider')
            .getFirst('nouislider');

        if (value && innerState) {
            const sameValues = innerState.every((e, i) => {
                return +e === +value[i];
            });
            if (!sameValues) {
                setValue(innerState);
                slider.set(innerState);
                setInnerState(null);
            }
        } else if (value && slider.get() && !innerState) {
            slider.set(value);
        }
    }, [innerState, options.id, setValue, value]);

    //Evento pendiente de cambio del rangeSlider
    useEffect(() => {
        if (options.id) {
            window.bronson
                .$$('#' + options.id + '.js-custom-range-slider')
                .component('custom-range-slider')
                .getFirst('nouislider')
                .on('change', e => {
                    if (options.customValues && e?.length > 1) {
                        let values = e;
                        values[0] = parseInt(values[0].split('.')[0]);
                        values[1] = parseInt(values[1].split('.')[0]);
                        if (!checkSameValues(values[0], values[1])) {
                            setInnerState(values);
                        }
                        //window.bronson.$$('#' + options.id + '.js-custom-range-slider').component('custom-range-slider').getFirst('nouislider').off();
                    } else {
                        setInnerState(parseInt(e[0]));
                    }
                });
        }
    }, [options.customValues, options.id]);

    //Evento pendiente de cambio del rangeSlider
    useEffect(() => {
        window.bronson
            .$$('#' + options.id + '.js-custom-range-slider')
            .component('custom-range-slider')
            .getFirst('nouislider')
            .on('update', function (e) {
                if (options.customValues && e?.length === 2) {
                    let valueMin = parseInt(e[0].split('.')[0]);
                    let valueMax = parseInt(e[1].split('.')[0]);
                    if (!options.isDate) {
                        valueMin = parseInt(e[0]).toLocaleString('ca');
                        valueMax = parseInt(e[1]).toLocaleString('ca');
                    }
                    setMinValue(valueMin);
                    setMaxValue(valueMax);
                }
            });
    }, [options.customValues, options.id, options.isDate, value]);

    const rangeSliderTypes = rangeSliderTypes => {
        let strRangeSliderTypes = '';
        if (rangeSliderTypes) {
            rangeSliderTypes.forEach(type => {
                switch (type) {
                    case 'top':
                        strRangeSliderTypes +=
                            'custom-range-slider-tooltip--top  ';
                        break;
                    case 'bottom':
                        strRangeSliderTypes +=
                            'custom-range-slider-tooltip--bottom  ';
                        break;
                    case 'small':
                        strRangeSliderTypes += 'c-custom-range-slider--small  ';
                        break;
                    default:
                        break;
                }
            });
        }
        return strRangeSliderTypes;
    };

    const onBlurInput = (e, code) => {
        let value = e.currentTarget.value;
        if (options.step) value = getArroundValue(e.currentTarget.value, code);

        if (code == 'min') {
            let maxVal = !options.isDate
                ? maxValue.replaceAll('.', '')
                : maxValue;
            if (!checkSameValues(value, maxVal)) setValue([value, maxVal]);
            else resetValues();
        } else {
            let minVal = !options.isDate
                ? minValue.replaceAll('.', '')
                : minValue;
            if (!checkSameValues(minVal, value)) setValue([minVal, value]);
            else resetValues();
        }
    };

    const onChangeInput = (e, code, valueDefault) => {
        let value = valueDefault
            ? e
            : e.currentTarget.value.replaceAll('.', '');
        if (value != '' && !/^\d+$/.test(value)) return false;

        if (!options.isDate && value != '') {
            e.currentTarget.value = parseInt(value).toLocaleString('ca');
            value = parseInt(value).toLocaleString('ca');
        }
        if (code == 'min') {
            if (value != minValue) setMinValue(value);
        } else {
            if (value != maxValue) setMaxValue(value);
        }
    };

    const getArroundValue = (val, code) => {
        let numberSteps = options.range[1] / options.step;
        let roundValue = 0;

        if (val != '') {
            let value = !options.IsDate
                ? parseInt(val.replaceAll('.', ''))
                : parseInt(val);
            let i = 1;

            while (i <= numberSteps && roundValue == 0) {
                if (value < options.step || value < options.range[0]) {
                    roundValue = 0;
                } else {
                    if (
                        value == options.step * (i - 1) ||
                        value == options.step * i
                    ) {
                        roundValue = value;
                    } else {
                        if (
                            value > options.step * (i - 1) &&
                            value < options.step * i
                        ) {
                            roundValue = options.step * (i - 1);
                        } else {
                            if (
                                value == options.step * (i - 1) ||
                                value == options.step * i
                            ) {
                                roundValue = value;
                            } else {
                                if (value >= options.step && i == numberSteps) {
                                    roundValue = options.step * i;
                                }
                            }
                        }
                    }
                }
                i++;
            }
        } else {
            if (code == 'min') roundValue = 0;
        }

        return roundValue;
    };

    const checkSameValues = (min, max) => {
        let same = false;

        return same;
    };

    const resetValues = () => {
        if (options.customValues) {
            let minValueAux = parseInt(options.range[0]);
            let maxValueAux = parseInt(options.range[1]);
            setMinValue(minValueAux);
            setMaxValue(maxValueAux);
            setValue([minValueAux, maxValueAux]);
        }
    };

    return (
        <div className="c-form-field">
            {options.label ? (
                <label className="c-form-field__label">{options.label}</label>
            ) : null}
            <div className="c-form-field__box">
                <div className="bronson-range">
                    <div
                        id={options.id}
                        className={
                            'c-custom-range-slider  js-custom-range-slider  u-mr-small ' +
                            rangeSliderTypes(options.type) +
                            (options.tooltips
                                ? ' custom-range-slider-tooltip--top'
                                : '')
                        }
                        data-custom-range-slider-tooltips={options.tooltips}
                        // data-custom-range-slider-start={options.start}
                        data-custom-range-slider-step={options.step}
                        /* data-custom-range-slider-pips={`{ "mode": "steps", "density":${options.pips}}`} */
                        data-custom-range-slider-snap={false}
                        data-custom-range-slider-range={`{ "min": ${options.range[0]}, "max": ${options.range[1]}}`}
                        disabled={options.disabled}
                        data-custom-range-slider-start={
                            options.customValues
                                ? '[' +
                                  options.range[0] +
                                  ',' +
                                  options.range[1] +
                                  ']'
                                : ''
                        }
                        data-custom-range-slider-connect={
                            options.customValues ? '[false, true, false]' : '[]'
                        }
                    ></div>
                    <div className="u-mt">
                        <div className="c-input bronson-range__input-left">
                            <input
                                className="c-input__input"
                                id=""
                                type="text"
                                placeholder="Min."
                                value={minValue}
                                onChange={e => onChangeInput(e, 'min')}
                                onBlur={e => onBlurInput(e, 'min')}
                                tabIndex="-1"
                            />
                        </div>
                        <p className="bronson-range__input-to">
                            {t.getTraduction('Hasta')}
                        </p>
                        <div className="c-input bronson-range__input-right">
                            <input
                                className="c-input__input"
                                id=""
                                type="text"
                                placeholder="Max."
                                value={maxValue}
                                onChange={e => onChangeInput(e, 'max')}
                                onBlur={e => onBlurInput(e, 'max')}
                                tabIndex="-1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

RangeSlider.propTypes = {
    /**Example: const optionsRanger = {
        step: 100,
        pips: 1000,
        range: [0, 1500],
        tooltips: true,
        type: ['bottom']
        //disabled: true
    }; */
    options: PropTypes.shape({
        id: PropTypes.string.isRequired,
        labelClass: PropTypes.string,
        step: PropTypes.number,
        pips: PropTypes.number,
        range: PropTypes.array, //Position 0 start, Position 1 end
        tooltips: PropTypes.bool,
        type: PropTypes.array,
        disabled: PropTypes.bool,
    }).isRequired,
    value: PropTypes.array.isRequired,
    setValue: PropTypes.func.isRequired,
};

export default memo(RangeSlider);
